import { Transform, TransformFnParams } from 'class-transformer';
import { get } from 'lodash-es';

export function GetByPath(path: string) {
  return Transform((params: TransformFnParams) => {
    return get(params.obj, path);
  });
}
